export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12 prose">
      <h1 className="text-2xl font-semibold text-atlas-ink">About the Instant Demo</h1>
      <p className="mt-4 text-atlas-ink">
        The MAPTRIUM Instant Demo is a free, no-account preview built by AtlasGeo Technologies LLC for federal
        and municipal teams. It produces a branded, shareable demo map from a single form so you can see what a real
        MAPTRIUM engagement looks like.
      </p>
      <p className="mt-4 text-atlas-ink">
        Ready for the full product?{' '}
        <a href="https://maptrium.com/" className="text-atlas-navy underline hover:text-atlas-gold-dark">
          Open MAPTRIUM
        </a>{' '}
        for the full pipeline: AGOL publish, DOCX + PPTX briefings, TAK feeds, hotspot analysis, and more.
        Sign up at{' '}
        <a href="https://maptrium.com/login" className="text-atlas-navy underline hover:text-atlas-gold-dark">
          maptrium.com
        </a>.
      </p>
      <p className="mt-4 text-atlas-ink">
        AtlasGeo Technologies is an SDVOSB/MBE firm specializing in transportation safety analysis, geographic mapping,
        and decision support for grants and operations.
      </p>
    </div>
  );
}
